<template>
  <div id="AddSchoolGatherPlace" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回學校集中地點列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
         <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>學校集中地點:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.schoolGatherPlace"
                  ref="inputData.schoolGatherPlace"
                  placeholder="請輸入學校集中地點"
                />
              </div>
            </td>
          </tr>




        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="AddSchoolGatherPlace()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "AddschoolGatherPlace",

  data() {
    return {
      mode: true,
      file: [{ name: "", RowId: "" }],
      inputFlag: false,
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        schoolGatherPlace:null,
         },
      currentPage: 1,
      cid: "",
      pageSize: 10,


    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  methods: {

      checkInput() {
      this.inputFlag = false;
      if (tools.empty(this.inputData.schoolGatherPlace)) {
        alert("請輸入學校集中地點");

        this.inputFlag = true;
        return;
      }

    },
    AddSchoolGatherPlace() {
      this.checkInput();
       let vm = this;
      if (vm.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/AddSchoolGatherPlace/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "增加學校集中地點成功");
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加學校集中地點失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },


    close() {
      this.$emit("hideModal");
    },
  },
  created() {
    console.log("======created AddSchoolGatherPlaceView =====");

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
